import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";

// create a web app in fireabse 
// then get your app config object from firebase console -> settings
const firebaseConfig = {
    apiKey: "AIzaSyDcquiLSffchDBT-QX03PIv_GikHqj2Us0",
    authDomain: "spomodoro-92855.firebaseapp.com",
    databaseURL: "https://spomodoro-92855-default-rtdb.firebaseio.com",
    projectId: "spomodoro-92855",
    storageBucket: "spomodoro-92855.appspot.com",
    messagingSenderId: "694595890485",
    appId: "1:694595890485:web:c5af38943a4850dbfdb07c"
  };

firebase.initializeApp(firebaseConfig);